import React from 'react';

const GameJams = () => {
  return (
    <div className="projects" id="game-jams">
      <h3 className="sub-title text text-EN">Game Jams</h3>
      <h3 className="sub-title text text-UA">Ігрові Джеми</h3>

      <ol className="project-items-block">
        <li>
          <div className="text text-EN">
            Participation in
            <a
              href="https://itch.io/jam/2019-spring-ue4jam-marketplace-takeover/rate/419656"
            >
              @EpicSpringJam2019
            </a>
          </div>
          <div className="text text-UA">
            Приймав участь у
            <a
              href="https://itch.io/jam/2019-spring-ue4jam-marketplace-takeover/rate/419656"
            >
              @EpicSpringJam2019
            </a>
          </div>
        </li>
        <li>
          <div className="text text-EN">
            Participation in
            <a href="https://itch.io/jam/2019-winter-ue4jam/rate/372848">
              @EpicWinterJam2019
            </a>
          </div>
          <div className="text text-UA">
            Приймав участь у
            <a href="https://itch.io/jam/2019-winter-ue4jam/rate/372848">
              @EpicWinterJam2019
            </a>
          </div>
        </li>
        <li>
          <div className="text text-EN">
            Participation in
            <a href="https://starman42.itch.io/toweltrip">
              @EpicMegaJam2018
            </a>
          </div>
          <div className="text text-UA">
            Приймав участь у
            <a href="https://starman42.itch.io/toweltrip">
              @EpicMegaJam2018
            </a>
          </div>
        </li>
      </ol>
    </div>
  );
};

export default GameJams;
